/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Next_DescInputs */

const en_fc_tut_next_desc = /** @type {(inputs: Fc_Tut_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See exactly what carries over, what is missing, and how to move your projects.`)
};

/**
* | output |
* | --- |
* | "See exactly what carries over, what is missing, and how to move your projects." |
*
* @param {Fc_Tut_Next_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_next_desc = /** @type {((inputs?: Fc_Tut_Next_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Next_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_next_desc(inputs)
});
export { fc_tut_next_desc as "fc.tut.next.desc" }